import Quill from 'quill';

interface FormFieldsOptions {
  items: { label: string; value: string }[];
}

class FormFieldsModule {
  quill: Quill;
  options: FormFieldsOptions;
  toolbar: any;

  constructor(quill: Quill, options: FormFieldsOptions) {
    this.quill = quill;
    this.options = options;
    this.toolbar = this.quill.getModule('toolbar');

    this.init();
  }

  init() {
    // Create a dropdown for form fields
    const formFieldsDropdown = document.createElement('select');
    formFieldsDropdown.classList.add('ql-form-fields');
    formFieldsDropdown.setAttribute('id', 'ql-form-fields-dropdown');

    // Add default option
    const defaultOption = document.createElement('option');
    defaultOption.value = '';
    defaultOption.textContent = '+ Form Fields';
    formFieldsDropdown.appendChild(defaultOption);

    // Populate dropdown with items from options
    this.options.items.forEach(item => {
      const option = document.createElement('option');
      option.value = item.value;
      option.textContent = item.label;
      formFieldsDropdown.appendChild(option);
    });

    // Add event listener for selection change
    formFieldsDropdown.addEventListener('change', (event: Event) => {
      const target = event.target as HTMLSelectElement;

      if (target.value) {
        this.insertFormField(target.value);
        target.value = ''; // Reset selection
      }
    });

    // Add the dropdown to the toolbar
    const toolbarContainer = this.toolbar.container;

    if (toolbarContainer) {
      const wrapper = document.createElement('span');
      wrapper.classList.add('ql-form-fields-wrapper');
      wrapper.appendChild(formFieldsDropdown);
      toolbarContainer.appendChild(wrapper);
    }
  }

  insertFormField(value: string) {
    const range = this.quill.getSelection(true);

    if (range) {
      this.quill.insertText(range.index, value, 'user');
      this.quill.setSelection(range.index + value.length, 0);
    }
  }
}

Quill.register('modules/formFields', FormFieldsModule);

export default FormFieldsModule;
